<template>
  <v-card>
    <v-card-title>
      {{ title }}
      <v-spacer></v-spacer>
      <span v-if="subtitle" class="subtitle">Reporting: {{ subtitle }}</span>
    </v-card-title>
    <p class="text-center" v-if="paginated">
      Page: {{ page }} of {{ numPages }}
    </p>

    <div class="header item item-grid">
      <div>
        <strong>Date</strong>
      </div>
      <div>
        <strong>Issued By</strong>
      </div>
      <div>
        <strong>Invoice #</strong>
      </div>
      <div>
        <strong>Description</strong>
      </div>
      <div>
        <strong>Category</strong>
      </div>
      <div>
        <strong>Total</strong>
      </div>
      <div></div>
    </div>
    <div class="item-grid item" v-for="item in expenses" :key="item._id">
      <div>{{ getDate(item.date) }}</div>
      <div>{{ item.issuedBy }}</div>
      <div>{{ item.invoiceNumber }}</div>
      <div>{{ item.description }}</div>
      <div>{{ item.category }}</div>

      <div>
        <MoneyFormat :value="item.totalAmount / 100"></MoneyFormat>
      </div>
      <div>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <EditExpense :expense="item" />
          </template>
          <span>Edit</span>
        </v-tooltip>
      </div>
    </div>
    <div v-if="paginated == true" class="text-center">
      <v-pagination v-model="page" :length="numPages"></v-pagination>
    </div>
  </v-card>
</template>
<script>
import { DateTime } from "luxon";
import MoneyFormat from "vue-money-format";
import EditExpense from "@/components/expense/EditExpense";

export default {
  props: ["expenses", "title", "subtitle", "paginated"],
  components: {
    MoneyFormat,
    EditExpense,
  },
  data() {
    return {
      page: 1,
    };
  },
  watch: {
    page() {
      this.$store.dispatch("setPageNumber", this.page);
      this.$store.dispatch("loadExpenses");
    },
  },
  methods: {
    deleteItem(id) {
      this.$store.dispatch("deleteTime", id);
    },
    getDate(dt) {
      let date = DateTime.fromISO(dt);
      return date.toFormat("LLLL dd, yyyy");
    },
    openExpense(id) {
      this.$router.push("/expenses/" + id);
    },
  },
  computed: {
    numPages() {
      return this.$store.getters.expensesNumPages;
    },
  },
};
</script>
<style scoped>
.edit-icon {
  cursor: pointer;
}
.page {
  max-width: 1200px;
}
.item-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 2fr 1fr 1fr 50px;
  /* padding: 5px; */
  grid-column-gap: 6px;
}

.item {
  border-bottom: 1px solid #e7e7e7;
  padding: 16px;
}
.client-name {
  color: green;
  font-size: 12px;
  margin-left: 12px;
}
.description {
  font-style: italic;
  color: gray;
}
.subtitle {
  color: green;
  font-size: 12px;
  margin-left: 20px;
}
@media screen and (max-width: 800px) {
  .header {
    display: none;
  }
  .item-grid {
    grid-template-columns: 1fr;
  }
}
</style>